"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBanorteStore = void 0;
const pinia_1 = require("pinia");
exports.useBanorteStore = (0, pinia_1.defineStore)("banorte", {
    state() {
        return {
            data: null,
            insurer: null,
            engancheAmount: 0,
            enganchePercentage: 10,
            warrantyType: "",
            extendedWarranty: {
                include: false,
                payment: 'Financiado',
                value: 0
            }
        };
    },
    actions: {},
});
